import { TLAI_FEATURE_FLAGS } from '@/constants';
import { useDevToolToggle } from '@/hooks/use-dev-tool-toggle';
import { useFeatureFlag } from '@/hooks/use-feature-flag';
import { MAX_OBJECT_IDS_PER_REQUEST } from '@/server/remedy/utils';

export function useCodeRemedyFlags() {
  const skipCommentingRules = useFeatureFlag<string[]>(TLAI_FEATURE_FLAGS.REMEDY_SKIP_COMMENTING_RULES, [
    'select_missing_comma',
    'sql_escape_host_variables',
    'align_parameters',
    'align_pseudo_comments',
    'align_type_expressions',
    'whitespace_end',
  ]);

  const enableFleRemediation = useFeatureFlag<boolean>(TLAI_FEATURE_FLAGS.FLE_REMEDIATION_ENABLED, false);
  const { value: enableRemediationAnalysis } = useDevToolToggle('CODE_REMEDY_ANALYSIS');
  const { value: enableRemediationReport, isLoading: remediationReportFlagLoading } =
    useDevToolToggle('CODE_REMEDY_SUMMARY_REPORT');

  const defaultRemedyCheckVariant = useFeatureFlag<string>(TLAI_FEATURE_FLAGS.DEFAULT_REMEDY_CHECK_VARIANT, '');

  const maxObjectIdsPerRequest = useFeatureFlag<number>(
    TLAI_FEATURE_FLAGS.MAX_OBJECT_IDS_PER_REQUEST,
    MAX_OBJECT_IDS_PER_REQUEST,
  );

  const maxFindingsObjectIdsPerRequest = useFeatureFlag<number>(
    TLAI_FEATURE_FLAGS.MAX_FINDINGS_OBJECT_IDS_PER_REQUEST,
    2000,
  );

  return {
    skipCommentingRules,
    enableFleRemediation,
    enableRemediationAnalysis,
    enableRemediationReport,
    remediationReportFlagLoading,
    defaultRemedyCheckVariant,
    maxObjectIdsPerRequest,
    maxFindingsObjectIdsPerRequest,
  };
}
